document.addEventListener('DOMContentLoaded', () => {
  // Inicializa todos los sliders tipo map (si hay varios)
  document.querySelectorAll('.slider-store-container').forEach((container) => {
    const wrapper = container.querySelector('.slider-wrapper');
    const track = container.querySelector('.map-track');
    const products = Array.from(container.querySelectorAll('.product-card-map'));
    const prevBtn = document.getElementById('map-prev');
    const nextBtn = document.getElementById('map-next');

    if (!wrapper || !track || products.length === 0) return;

    let index = 0;

    function getVisibleCount() {
      if (window.innerWidth <= 480) return 1;
      if (window.innerWidth <= 768) return 2;
      if (window.innerWidth <= 1024) return 3;
      return parseInt(track.dataset.visibleCount) || 4;
    }

    // Devuelve el offset en px que alinea el producto 'index' al inicio visible (left)
    function calcOffsetForIndex(i) {
      // Asegurarnos de que el producto exista
      const first = products[0];
      const target = products[i];
      if (!first || !target) return 0;

      // offsetLeft es relativo al offsetParent (el track), por eso funciona bien
      const base = first.offsetLeft;
      const targetLeft = target.offsetLeft;
      return targetLeft - base;
    }

    function clamp(val, min, max) {
      return Math.max(min, Math.min(max, val));
    }

    function updateSlider() {
      const visibleCount = getVisibleCount();
      const maxIndex = Math.max(0, products.length - visibleCount);

      // aseguramos index válido
      if (index > maxIndex) index = maxIndex;
      if (index < 0) index = 0;

      // Offset objetivo en px
      const desiredOffset = calcOffsetForIndex(index);

      // ancho máximo que puede desplazarse el track (scrollWidth - wrapper width)
      const maxOffsetPx = track.scrollWidth - wrapper.clientWidth;

      // Clamp del offset para no pasarnos
      const offsetPx = clamp(desiredOffset, 0, maxOffsetPx);

      // Aplicar transform (negativo porque movemos el track hacia la izquierda)
      track.style.transform = `translateX(${-offsetPx}px)`;
    }

    // Botones
    nextBtn.addEventListener('click', () => {
      const visibleCount = getVisibleCount();
      const maxIndex = Math.max(0, products.length - visibleCount);

      if (index < maxIndex) {
        index += 1; // avanza una card
      } else {
        index = 0; // loop al inicio (opcional)
      }
      updateSlider();
    });

    prevBtn.addEventListener('click', () => {
      const visibleCount = getVisibleCount();
      const maxIndex = Math.max(0, products.length - visibleCount);

      if (index > 0) {
        index -= 1;
      } else {
        index = maxIndex; // ir al final (opcional)
      }
      updateSlider();
    });

    // Swipe touch support (arrastrar sobre el wrapper)
    let startX = 0;
    let currentTranslate = 0;
    let isDragging = false;

    wrapper.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, {passive: true});

    wrapper.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const moveX = e.touches[0].clientX;
      const diff = startX - moveX;
      // No movemos el track en tiempo real para evitar glitches; solo guardamos el diff
      // (podrías implementar dragging real si lo deseas)
      // aquí no hacemos nada, esperamos al touchend para snap al siguiente/previo
    }, {passive: true});

    wrapper.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : startX;
      const diff = startX - endX;

      const threshold = 40; // px mínimo para considerar swipe
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // swipe izquierda -> next
          nextBtn.click();
        } else {
          // swipe derecha -> prev
          prevBtn.click();
        }
      }
    });

    // Recalcular cuando cambia el tamaño (para gaps y responsive)
    window.addEventListener('resize', () => {
      // recalcular inmediatamente después de resize
      // añadimos pequeño timeout para que el layout termine de recomponer
      setTimeout(updateSlider, 100);
    });

    // forzamos overflow hidden en wrapper (asegurar que no se vean cards cortadas)
    wrapper.style.overflow = 'hidden';
    track.style.willChange = 'transform';
    track.style.transition = 'transform 400ms ease-in-out';

    // Inicializar
    updateSlider();
  });
});














document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => {
          if (!response.ok) throw new Error('Error al agregar al carrito');
          return response.json();
        })
        .then(() => {
          // 🔥 Pedimos las secciones del drawer + header (para el icono del carrito)
          return fetch('/?sections=cart-drawer,header,cart-icon-bubble');
        })
        .then(response => response.json())
        .then(data => {
          const parser = new DOMParser();

          // 🧩 Actualizar drawer
          if (data['cart-drawer']) {
            const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
            const newDrawer = doc.querySelector('#CartDrawer');
            const drawerContainer = document.querySelector('#CartDrawer');
            if (drawerContainer && newDrawer) {
              drawerContainer.innerHTML = newDrawer.innerHTML;
            }
          }

          // 🧩 Actualizar ícono del carrito (cart bubble o header)
          if (data['cart-icon-bubble']) {
            const doc2 = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
            const newBubble = doc2.querySelector('[data-cart-count], .cart-count-bubble, .cart-count');
            const currentBubble = document.querySelector('[data-cart-count], .cart-count-bubble, .cart-count');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            } else {
              // Reemplaza toda la sección si no encuentra el elemento exacto
              const newSection = doc2.querySelector('[id^="shopify-section-"]');
              const currentSection = document.querySelector('#shopify-section-cart-icon-bubble');
              if (newSection && currentSection) currentSection.replaceWith(newSection);
            }
          }

          // 🧩 Si el header contiene el icono del carrito, actualizamos el header completo también
          if (data['header']) {
            const doc3 = parser.parseFromString(data['header'], 'text/html');
            const newHeader = doc3.querySelector('header');
            const currentHeader = document.querySelector('header');
            if (newHeader && currentHeader) {
              const currentCartIcon = currentHeader.querySelector('[data-cart-count], .cart-count-bubble, .cart-count');
              const newCartIcon = newHeader.querySelector('[data-cart-count], .cart-count-bubble, .cart-count');
              if (newCartIcon && currentCartIcon) {
                currentCartIcon.innerHTML = newCartIcon.innerHTML;
              }
            }
          }

          // 🧩 Abrir el drawer visualmente
          const cartDrawerEl = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
          if (cartDrawerEl) {
            if (typeof cartDrawerEl.open === 'function') {
              cartDrawerEl.open();
            } else {
              cartDrawerEl.classList.add('active');
              const inner = cartDrawerEl.querySelector('.drawer__inner');
              if (inner) inner.classList.add('is-active');
              document.body.classList.add('overflow-hidden');
            }
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
    });
  });
});





